import React, { useState } from 'react'
import { Form, Input, Button, Popover, message } from 'antd'
import { UserOutlined, MailOutlined, TabletOutlined, UnlockOutlined } from '@ant-design/icons'

import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
// import { runInAction, set } from 'mobx'
//密码强度
import zxcvbn from 'zxcvbn'
import { runInAction, set } from 'mobx'

const StepTwo = () => {
  const { RegisterStore } = useStore()

  //密码强度
  const [strength, setStrength] = useState('0')
  const passwordStrength = (e) => {
    setStrength(zxcvbn(e.target.value).guesses_log10)
  }
  const content = (
    <div>
      <meter min="0" max="12" low="4" high="8" optimum="10" value={strength} style={{ width: '100%' }}></meter>
      <div style={{ color: '#7f7f7f' }}>密码长度8-16位,数字、字母、字符至少包含两种</div>
    </div>
  );
  //密码强度
  //输入手机号
  const onChange = (e) => {
    runInAction(() => {
      set(RegisterStore, { mobile: e.target.value })
    })
  }

  //短信验证
  let [num, setNum] = useState(0);
  const verifiedSubmit = () => {
    if (RegisterStore.mobile) {
      RegisterStore.postcode(RegisterStore.mobile)
      let a = 60;
      const timeChange = setInterval(() => {
        a = a - 1
        setNum(a)
        if (a === 0) {
          clearInterval(timeChange)
        }
      }, 1000);
    } else {
      message.error('请先输入要注册的手机号！')
    }


  }
  return (
    <>

      <Form.Item
        name="username"
        rules={[
          {
            required: true,
            message: '请输入账户/请输入正确的用户名',
          },
        ]}
      >
        <Input size="large" placeholder="请输入注册用户名" prefix={<UserOutlined className="icon" />} />
      </Form.Item>
      <Form.Item name="mobile"
        rules={[
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号码格式不对',
            // validateTrigger: 'onBlur'
          },
          { required: true, message: '请输入手机号' }
        ]}
      >
        <Input size="large" placeholder="请输入注册手机号" prefix={<TabletOutlined className="icon" />} onChange={onChange} />
      </Form.Item>
      <Form.Item >
        <div className='fdbj'>
          <div className='fdbj-left' style={{ width: '500px' }}>
            <Form.Item
              name="smscode"
              rules={[
                { len: 6, message: '请输入短信验证码', validateTrigger: 'onBlur' },
                { required: true, message: '请输入短信验证码' }
              ]}
              noStyle
            >
              <Input size="large" placeholder="请输入验证码" maxLength={6} prefix={<MailOutlined className="icon" />} />
            </Form.Item>
          </div>
          <div className='fdbj-right'>
            <Button type="primary" className="login-form-button" style={{ padding: '8px 10px', width: '150px' }}
              loading={num !== 0} onClick={verifiedSubmit}>{num === 0 ? '获取验证码' : num + '秒'}</Button>
          </div>
        </div>
      </Form.Item>
      <Popover placement="rightTop" content={content} trigger="click">
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: '请输入密码',
            },
          ]}
          autoComplete="off"
        >
          <Input.Password size="large" placeholder="设置密码|密码长度8-16位,数字、字母、字符至少包含两种" prefix={<UnlockOutlined className="icon" />} onChange={passwordStrength} autoComplete='new-password' />
        </Form.Item>
      </Popover>
      <Form.Item
        name="quepassword"
        rules={[
          {
            required: true,
            message: '请输确认密码',
          },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve()
              }
              return Promise.reject('您输入的两次密码不一致')
            },
          })
        ]}
        autoComplete='new-password'
      >
        <Input.Password size="large" placeholder="请确认密码" prefix={<UnlockOutlined className="icon" />} />
      </Form.Item>
    </>
  )
}

export default observer(StepTwo)
